import { ConversionPeriod } from 'pages/Monitoring/OrderConversion/OrderConversionList/OrderConversionListPeriodToggle/OrderConversionListPeriodToggle';
import { getPeriod } from 'utils/getPeriod';

export const PERIOD_PRESETS = {
  [ConversionPeriod.Hour1]: getPeriod({ hours: 1 }),
  [ConversionPeriod.Hour4]: getPeriod({ hours: 4 }),
  [ConversionPeriod.Hour8]: getPeriod({ hours: 8 }),
  [ConversionPeriod.Hour12]: getPeriod({ hours: 12 }),
};
